module.exports = __webpack_public_path__ + "static/img/IMG_20241031_175746.a85c7c24.jpg";